import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useState } from 'react';
import styles from './suicideRiskAlerts.module.css';
import Modal from '../modals/modal/Modal';
import RiskAlertCard from './riskAlertCard';
import RiskDetailModal from './riskDetailModal';
import { useAppSelector } from '../../services/hooks';
import { adminSelector } from '../../services/selectors/user.selectors';
import { useGetRiskAlertsQuery, RiskAlertServerResponse } from '../../services/api/riskAlerts.api';
import i18n from "../../i18n";
import ExportTableButtons from '../exportTableButtons/ExportTableButtons';

const SuicideRiskAlerts: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'updates' | 'history'>('updates');
    
    const { data: alerts, isLoading, error } = useGetRiskAlertsQuery({});
    
    const { data: archivedAlerts, isLoading: isLoadingArchived } = useGetRiskAlertsQuery({
        closed: true,
    }, {
        skip: activeTab !== 'history', // Only fetch when history tab is active
    });
    
    const [selectedAlert, setSelectedAlert] = useState<RiskAlertServerResponse | null>(null);
    const [deletingAlertId, setDeletingAlertId] = useState<number | null>(null);
    const [showAll, setShowAll] = useState(false);

    const handleAlertProcessed = (alertId: number) => {
        setDeletingAlertId(alertId);
        
        // אנימציה בלבד - ההתראה נשארת במערכת לצורך מעקב
        setTimeout(() => {
            setDeletingAlertId(null);
            setSelectedAlert(null);
        }, 600);
    };
      

    const currentAlerts = activeTab === 'updates' ? alerts : archivedAlerts;
    const isLoadingCurrent = activeTab === 'updates' ? isLoading : isLoadingArchived;
    
    if (isLoadingCurrent && activeTab === 'updates') {
        return (
            <div className={styles.container}>
                <div className={styles.loadingState}>
                    <div className={styles.spinner}></div>
                    <p>{t('LOADING')}</p>
                </div>
            </div>
        );
    }
    
    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.errorState}>
                    <div className={styles.errorIcon}>⚠️</div>
                    <h3>{t('ERROR_LOADING_ALERTS')}</h3>
                    <p>{t('PLEASE_TRY_AGAIN')}</p>
                </div>
            </div>
        );
    }
    return (
        <div className={styles.container}>
            <div className={styles.headerCard}>
                <div className={styles.alertInfo}>
                    <div className={styles.alertIconWrapper}>
                        <span className={styles.alertIcon}>⚠️</span>
                        <div className={styles.pulse}></div>
                    </div>
                    <div className={styles.alertText}>
                        <h3>{t('RISK_ALERTS')}</h3>
                        <p dir={i18n.dir()}><span className={styles.alertCount}>{alerts?.length || 0}</span> {t('HIGH_RISK_PATIENTS_CHECK')}</p>
                    </div>
                </div>
                {/* <div className={styles.userSection}>
                    <div className={styles.userAvatar}>{admin.firstName[0]}</div>
                    <span className={styles.userName}>{admin.firstName}</span>
                </div> */}
            </div>

            <div className={styles.headerSection}>
                <div className={styles.tabsContainer}>
                    <button
                        className={`${styles.tabButton} ${activeTab === 'updates' ? styles.activeTab : ''}`}
                        onClick={() => {
                            setActiveTab('updates');
                            setShowAll(false);
                        }}
                    >
                        {t('ACTIVITY_ALERTS')}
                    </button>
                    <button
                        className={`${styles.tabButton} ${activeTab === 'history' ? styles.activeTab : ''}`}
                        onClick={() => {
                            setActiveTab('history');
                            setShowAll(false);
                        }}
                    >
                        {t('RISK_HISTORY')}
                    </button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <ExportTableButtons
                        entity="RiskAlerts"
                        dataRows={(currentAlerts ?? []).map(a => ({
                            Id: a.id,
                            PatientName: a.patientFullName,
                            RiskLevel: a.riskLevel,
                            RiskLabel: a.riskLabel,
                            Source: a.sourceName,
                            CreatedAt: new Date(a.createdAt).toLocaleDateString('he-IL'),
                            Status: a.actionsPerformed ? t('PROCESSED') : t('PENDING'),
                        }))}
                    />
                </div>
            </div>

            {isLoadingCurrent && activeTab === 'history' ? (
                <div className={styles.loadingState}>
                    <div className={styles.spinner}></div>
                    <p>{t('LOADING')}</p>
                </div>
            ) : (
                <>
                    <div className={styles.alertsList}>
                        {(showAll ? currentAlerts : currentAlerts?.slice(0, 4))?.map((alert) => (
                            <RiskAlertCard
                                key={alert.id}
                                alert={alert}
                                onView={() => setSelectedAlert(alert)}
                                isDeleting={deletingAlertId === alert.id}
                            />
                        ))}
                    </div>

                    {(!currentAlerts || currentAlerts.length === 0) && (
                        <div className={styles.emptyState}>
                            <div className={styles.emptyIcon}>✅</div>
                            <p>{t('NO_RISK_ALERTS_NOW')}</p>
                        </div>
                    )}

                    {currentAlerts && currentAlerts.length > 4 && (
                        <button className={styles.viewAllButton} onClick={() => setShowAll(!showAll)}>
                            <span>{showAll ? t('SHOW_LESS') : t('SHOW_ALL')}</span>
                            <div className={styles.buttonGlow}></div>
                        </button>
                    )}
                </>
            )}

            {selectedAlert && (
                <Modal onClose={() => setSelectedAlert(null)} wide={true}>
                    <RiskDetailModal
                        alert={selectedAlert as RiskAlertServerResponse}
                        onClose={() => setSelectedAlert(null)}
                        onSave={() => handleAlertProcessed(selectedAlert.id)}
                    />
                </Modal>
            )}
        </div>
    );
};


export default SuicideRiskAlerts;